/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#contact-us-links[_ngcontent-%COMP%]{background-color:#f3f3f3;color:#828282}#contact-us-links[_ngcontent-%COMP%]   #links-columns[_ngcontent-%COMP%]{max-width:1140px;-webkit-box-align:center;align-items:center}#contact-us-links[_ngcontent-%COMP%]   #links-columns[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{font:12px PoppinsSemiBold,sans-serif;letter-spacing:1px}#contact-us-links[_ngcontent-%COMP%]   #links-columns[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]   #chat-link[_ngcontent-%COMP%]{color:#ff6000!important;cursor:pointer}"];
export { styles as styles };
//# sourceMappingURL=contact-us-links.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/contact-us/contact-us-links/contact-us-links.component.scss.shim.ngstyle.js
// module id = 1736
// module chunks = 27 28 29